import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader' 
import "./storesStyles.css"
import { FaBuilding, FaInbox, FaPhone,FaGlobe ,} from 'react-icons/fa'

const StoreContacts = () => {
    const [contacts, setContacts] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const { name } = useParams()

    useEffect(() => {
        const getContacts = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/contacts`)
                if (response?.data) {
                    setContacts(response.data.contacts)
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Failed to fetch contacts')
            } finally {
                setIsLoading(false)
            }
        }

        getContacts()
    }, [name])

    if (isLoading) return <Loader />

    if (!contacts) return <p className="no-contacts">No contacts found.</p>

    return (
        <div className="store-contacts-container">
            <h2 className="title">Store Contacts</h2>
             <div className="store-address-container">
            <div className="address-details">
                <div><span className="label"><FaInbox />Email:</span> {contacts.email}</div>
                <div><span className="label"><FaPhone/>Phone:</span> {contacts.phone}</div>
                <div><span className="label"><FaPhone/>Phone2:</span> {contacts.phone}</div>
                <div><span className="label"><FaGlobe/>website:</span> {contacts.phone}</div>
            </div>
        </div>
        </div>
    )
}

export default StoreContacts
